<p
  *ngIf="(itemsWithParts$ | async).length === 0; else itemsDisplay"
  [testId]="testIds.NO_ITEMS_ADDED"
>
  <em>No items added yet</em>
</p>
<ng-template #itemsDisplay>
  <table
    mat-table
    [dataSource]="itemsWithParts$"
    [testId]="testIds.JOB_LIST_TABLE"
  >
    <ng-container matColumnDef="job_number">
      <th mat-header-cell *matHeaderCellDef>Job ID</th>
      <td mat-cell *matCellDef="let element">
        <a [routerLink]="['/workshop/job', element.id]">{{ element.id }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="repairable">
      <th mat-header-cell *matHeaderCellDef>Item</th>
      <td mat-cell *matCellDef="let element">
        {{ element | workshopJobName }}
        <p *ngIf="element.details" class="small">
          <strong>Details:</strong> {{ element.details }}
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let element">
        {{ element.work_status | workshopJobStatusLabel }}
      </td>
    </ng-container>

    <ng-container matColumnDef="booked_in">
      <th mat-header-cell *matHeaderCellDef>Booked in</th>
      <td mat-cell *matCellDef="let element">
        <p>{{ element.booked_in_at | date : 'dd/MM/yyyy' }}</p>
        <p>
          <small
            >By {{ element.booked_in_by | userIdToName | async }} in
            {{ element.booked_in_location | locationNameFromId | async }}</small
          >
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="total_cost">
      <th mat-header-cell *matHeaderCellDef>Cost</th>
      <td mat-cell *matCellDef="let element">
        {{ element.total_cost | currency : currency }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <a [routerLink]="['/workshop/job', element.id]">View Workshop Job</a> |
        <a class="cursor-pointer" (click)="doPrint(element.id)">Print</a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</ng-template>
